// extracted by mini-css-extract-plugin
module.exports = {"header":"infoStop_header__2FE-R","div":"infoStop_div__3FWG7","link":"infoStop_link__diUMY","lines":"infoStop_lines__17ZBu","time":"infoStop_time__2oP2Z"};